import { SMEReport } from 'api';
import * as actions from './actionTypes';

export interface IReportStore {
    sme: SMEReport[]
}

export const INITIAL_STATE:IReportStore = {
    sme: []
}

const Report = (state = INITIAL_STATE, action:{type: string, payload:any}) => {
    switch (action.type) {
        case actions.SET_SME_REPORT:
            state = {
                ...state,
                sme: action.payload
            }
            break;

        case actions.RESET_REPORTS:
            state = { ...INITIAL_STATE };
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default Report;